
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Breadcrumb } from "@boozallen-uip/uswds-react-core";
import { ACCESS_DENIED, ACCESS_WAITING, ACCESS_NO_LOGIN, BASE_TITLE, NO_VENDOR_FOUND, HOME_URL, FOR_VENDORS_URL, VENDOR_OVERVIEW_URL } from "../../utlities/core.constants";
// import { VendorContext } from "./VendorContext";
import "./VendorOverview.page.scss";
import { UserContext } from "../UserContext";
import AccessStatus from "../../components/AccessStatus.component";
import { SectionContainer } from "../shared.styled";

import VendorDetail from "./VendorDetail.component";
import useEntity from "../../hooks/useEntity.hook";
import usePrimaryPoc from "../../hooks/usePrimaryPoc.hook";
import StatusBar from "../../components/StatusBar.component";

export default function Vendor() {
  const { vendorId } = useParams();
  const [entity, setEntity] = useState(null);
  const [primaryPoc, setPrimaryPoc] = useState(null);

  const { hasPendingRequestAccess, checkEntityAccessLevel, isLoggedIn, isVendorUser, isSuperUser } = useContext(UserContext);
  const { getVendor } = useEntity();
  const { getPrimaryPoc } = usePrimaryPoc();

  useEffect(() => {
    if(!vendorId){
      return;
    }

    (async() => {
      const entityResponse = await getVendor(vendorId);
      setEntity(entityResponse);

      if(entityResponse && entityResponse.primaryPocId){
        const primaryPocResponse = await getPrimaryPoc(entityResponse.primaryPocId);
        setPrimaryPoc(primaryPocResponse);
      }
    })()

    window.scrollTo({ top: 0});
  }, [vendorId])
  document.title = `${BASE_TITLE} - Vendor Overview`;

  if (!isLoggedIn()) {
    return (
      <SectionContainer className='pt-4'><AccessStatus access={ACCESS_NO_LOGIN} /></SectionContainer>
    )
  }

  if (!checkEntityAccessLevel()) {
    return (
      <SectionContainer className='pt-4'><AccessStatus access={ACCESS_DENIED} /></SectionContainer>
    )
  }

  if (hasPendingRequestAccess) {
    return (
      <SectionContainer className='pt-4'><AccessStatus access={ACCESS_WAITING} /></SectionContainer>
    )
  }

  if(isVendorUser && !isSuperUser){
    return <SectionContainer className='pt-4'><StatusBar status={ACCESS_WAITING} title="Error" description={`${NO_VENDOR_FOUND}`} /></SectionContainer>
  }

  if(!entity){
    return null;
  }

  return ( <div>
    <SectionContainer className='pt-4'>
      <div>
        <Breadcrumb links={[{"href": HOME_URL, "text": "Home"}, {"href": FOR_VENDORS_URL, "text": "For Vendors"}, {"href": VENDOR_OVERVIEW_URL, "text": entity?.name}]} />
      </div>
      <VendorDetail entity={entity} primaryPoc={primaryPoc} />
    </SectionContainer>
    </div>
  );
}
